import queryString from 'query-string';

export const isExternalLink = (url: string) => url.match(/^https?:/) || url.match(/^\/director\//) || url === '/';

export const getQueryValue = (locationSearch: string, key: string): string | null => {
  const query = queryString.parse(locationSearch);
  const value = query[key];
  return Array.isArray(value) ? value[0] : value;
};
